<div class="image-carousel {{scheme}}">
  <section
    [ngClass]="{carousel: isCarousel}"
    class="is-set"
    (swipeleft)="next(true)"
    (swiperight)="previous(true)"
    data-hm-recognizer-options="{directions: 'DIRECTION_HORIZONTAL'}"
    >
    @for (item of items; track item) {
      <article [ngStyle]="{order: item.carouselOrder}">
        @if (item.id == 'video') {
          <figure
            class="slide video"
            (click)="showVideo(item)"
            >
            @if (item.thumbnail) {
              <img
                [src]="item.thumbnail"
                alt="Play video"
                />
            }
            <span class="fa fa-youtube-play"></span>
          </figure>
        }
        @if (item.id != 'video' && item.company_image_id) {
          <figure
            class="slide"
            >
            <img
              [src]="getImageUrl(item)"
              alt="{{ item.title }}"
              />
          </figure>
        }
      </article>
    }
  </section>
  @if (isCarousel) {
    <div class="buttonContainer">
      <button class="previous" (click)="previous(true)">
        <i class="fa fa-solid fa-chevron-left"></i>
      </button>
      <button class="next" (click)="next(true)">
        <i class="fa fa-solid fa-chevron-right"></i>
      </button>
    </div>
  }
</div>
